module.exports = __webpack_public_path__ + "static/media/pending.738376d6.svg";